<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
	<div class="o-grid o-grid--wrap">
		<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Consents.Table.Date' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-35 u-no-p">
			<p class="c-text c-text--gray" aria-hidden="true">{{ 'Common.Description' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
			<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{ 'Consents.Table.Terms_Of_Service' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
			<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{ 'Consents.Table.Privacy_Policy' | translate }}</p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
			<p class="c-text c-text--gray c-text--right" aria-hidden="true">{{ 'Consents.Table.Consents' | translate }}</p>
		</div>
	</div>
</div>
<ul class="c-list">
	<li *ngFor="let consent of vm.consents | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
		<div class="c-panel u-no-p" panel [isOpen]="consent._isOpen">
			<div class="c-content c-content--border-bottom u-no-ph@md-and-up" [ngClass]="{'u-no-b@up-to-md': vm.consents?.length <= vm.pageSize}">
				<div class="o-grid o-grid--wrap o-grid--bottom">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@sm-and-up o-grid__cell--w-20@md-and-up u-no-p o-grid__cell--o3@md-and-up">
						<div class="o-grid o-grid--center-v">
							<div class="o-grid__cell u-no-p">
								<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Consents.Table.Terms_Of_Service' | translate }}:</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
								<a id="termsOfServiceDownload{{$index}}" href="{{ vm.webTosLink }}" target="_blank" type="button" class="c-text c-text--uppercase c-text--bold">{{'Consents.Table.View' | translate}}</a>
							</div>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@sm-and-up o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--o4@md-and-up o-grid__cell--right">
						<div class="o-grid o-grid--center-v">
							<div class="o-grid__cell u-no-p">
								<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Consents.Table.Privacy_Policy' | translate }}:</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
								<a id="privacyPolicyDownload{{$index}}" href="{{ vm.webPPLink }}" target="_blank" class="c-text c-text--uppercase c-text--bold">{{'Consents.Table.View' | translate}}</a>
							</div>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-35@md-and-up o-grid__cell--o2@md-and-up u-no-p u-ost-md@up-to-md u-osb-md@up-to-md">
						<p class="u-sr-only">{{ 'Common.Description' | translate }}:</p>
						<p class="c-text c-text--bold@up-to-md">{{ consent.description }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-60 o-grid__cell--w-15@md-and-up o-grid__cell--o1@md-and-up u-no-p">
						<p class="u-sr-only">{{ 'Consents.Table.Date' | translate }}:</p>
						<p class="c-text c-text--sm@up-to-md">{{ consent.modified | date:'dd.MM.yyyy HH:mm:ss' }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-40 o-grid__cell--w-15@md-and-up u-no-p o-grid__cell--o5@md-and-up">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
								<div class="c-panel__header c-panel__header--sm">
									<a id="toggleConsentDetails{{$index}}" href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{consent._isOpen ? ('Consents.Table.Close' | translate) : ('Consents.Table.View' | translate)}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="c-panel__content c-panel__content--bg u-no-ph">
				<div class="c-content">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p" *ngIf="consent">
							<item-notification icon="user" [text]="getNotificationText(consent)" [theme]="3"></item-notification>
							<list-consents [(consent)]="consent"></list-consents>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
</ul>
